export function isAttStorefront(slug: string | null | undefined): boolean {
  if (!slug) return false

  const attSlugs = new Set([
    'mobile-carrier-liquidations',
    'att',
    'mobilecarrier',
  ])

  const normalized = slug.toLowerCase()
  return attSlugs.has(normalized)
}

export function isSumitomoStorefront(slug: string | null | undefined): boolean {
  if (!slug) return false

  const sumitomoSlugs = new Set(['sumitomo', 'sumitomo-corporation'])

  const normalized = slug.toLowerCase()
  return sumitomoSlugs.has(normalized)
}
